"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaSourceOrigin = exports.AudioBlockType = exports.MediaType = exports.ModelEvent = exports.UploadStatus = exports.MediaLibraryComponentType = void 0;
var MediaLibraryComponentType;
(function (MediaLibraryComponentType) {
    MediaLibraryComponentType["audioLibraryPage"] = "AudioLibraryPage";
    MediaLibraryComponentType["videoLibraryPage"] = "VideoLibraryPage";
    MediaLibraryComponentType["imageLibraryPage"] = "ImageLibraryPage";
    MediaLibraryComponentType["documentsLibraryPage"] = "DocumentsLibraryPage";
    MediaLibraryComponentType["imageStockLibrary"] = "ImageStockLibrary";
})(MediaLibraryComponentType || (exports.MediaLibraryComponentType = MediaLibraryComponentType = {}));
var UploadStatus;
(function (UploadStatus) {
    UploadStatus["loaded"] = "loaded";
    UploadStatus["failed"] = "failed";
    UploadStatus["inProgress"] = "inProgress";
})(UploadStatus || (exports.UploadStatus = UploadStatus = {}));
var ModelEvent;
(function (ModelEvent) {
    ModelEvent["loaded"] = "loaded";
    ModelEvent["failed"] = "failed";
    ModelEvent["progressed"] = "progressed";
})(ModelEvent || (exports.ModelEvent = ModelEvent = {}));
var MediaType;
(function (MediaType) {
    MediaType["audio"] = "audio";
    MediaType["video"] = "video";
    MediaType["document"] = "documents";
    MediaType["image"] = "images";
})(MediaType || (exports.MediaType = MediaType = {}));
var AudioBlockType;
(function (AudioBlockType) {
    AudioBlockType["voiceOver"] = "VoiceOver";
    AudioBlockType["singleAudio"] = "SingleAudio";
})(AudioBlockType || (exports.AudioBlockType = AudioBlockType = {}));
var MediaSourceOrigin;
(function (MediaSourceOrigin) {
    MediaSourceOrigin["upload"] = "upload";
    MediaSourceOrigin["recording"] = "recording";
    MediaSourceOrigin["textToSpeech"] = "text-to-speech";
})(MediaSourceOrigin || (exports.MediaSourceOrigin = MediaSourceOrigin = {}));
